/**
 * Created by Mark on 04/04/2017.
 */



import React from 'react';

export default class CDNImage extends React.Component {

    constructor(props){
        super();
        this.props = props;
        this.cdn = 'https://d3rmny3222a99w.cloudfront.net'+this.getDictionary();
    }

    getDictionary(){
        if(this.props.isVocab){
            return "/vocabs"
        }

        if(this.props.isGameIcon)
        {
            return "/img/gameselectionimages"
        }


        return '';
    }

    render(){
        const style ={
            maxWidth:this.props.size,
        }

        return <img className={this.props.className} style={style} src={this.cdn+'/'+this.props.src} />
    }

}


// WEBPACK FOOTER //
// ./src/components/media/image.js